import React, { useEffect, useMemo, useState } from 'react';
import {
  getLocalIconSrc,
  getRemoteIconSrc,
  getScriptColor,
  getScriptInitials,
  resolveScriptKey,
} from '../utils/scriptIcon';
import './../ScriptIcon.css';

const ScriptIcon = ({ name, symbol, size = 36, className = '' }) => {
  const key = useMemo(() => resolveScriptKey(symbol, name), [symbol, name]);
  const sources = useMemo(() => {
    const local = getLocalIconSrc(key);
    if (local) return [local];
    return [getRemoteIconSrc(key)].filter(Boolean);
  }, [key]);
  const [sourceIndex, setSourceIndex] = useState(0);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setSourceIndex(0);
    setFailed(false);
  }, [key]);

  const handleError = () => {
    if (sourceIndex + 1 < sources.length) {
      setSourceIndex((current) => current + 1);
      return;
    }
    setFailed(true);
  };

  if (!key || failed || !sources[sourceIndex]) {
    return (
      <span
        className={`script-icon script-icon-fallback ${className}`}
        style={{ width: size, height: size, background: getScriptColor(key) }}
        aria-hidden="true"
      >
        {getScriptInitials(key, name)}
      </span>
    );
  }

  return (
    <img
      key={`${key}-${sourceIndex}`}
      className={`script-icon ${className}`}
      src={sources[sourceIndex]}
      alt=""
      width={size}
      height={size}
      style={{ width: size, height: size }}
      onError={handleError}
    />
  );
};

export default ScriptIcon;
